export const className = (...cls: Array<string | boolean | undefined | null>)=> cls.filter(Boolean).join(" ")

const rtlLocales = ["ar", "he", "ug_cn"]
export function setDir(locale: string){
  if(rtlLocales.some(t=>locale.startsWith(t))){
    document.body.dir = "rtl"
  }else if(document.body.dir){
    document.body.removeAttribute("dir")
  }
}

// 部分资源存在fallback，比如he资源没找到，会去找en资源，此时应该移除dir属性
export function fixDir(source: string){
  if(rtlLocales.some(t=>source.includes(`/${t}/`))){
    document.body.removeAttribute("dir")
  }
}
